<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_privacy.jpeg')">
      <div class="content pos-relative legal-content">
        <go-to-top />
        <h1 class="main-title">
          プライバシーポリシー
        </h1>
        <h2 class="update-time">
          最終更新日：2026年6月18日
        </h2>
        <p>
          TIGER CASINOをご利用いただく前に、本プライバシーポリシーをご確認ください。お客様がTIGER CASINOのウェブサイト、モバイルサイト、アプリ、ゲーム、決済機能、サポートその他のサービスを利用することにより、本ポリシーに同意したものとみなされます。同意いただけない場合は、サービスの利用を中止してください。
        </p>

        <h3 class="terms-title">
          1. 基本方針
        </h3>
        <p>
          TIGER CASINOは、お客様の個人情報を重要な情報として取り扱い、適用されるデータ保護法、プライバシー関連法令、ライセンス条件および社内規程に従い、適切な管理に努めます。
        </p>
        <p>
          本ポリシーは、必要に応じて更新される場合があります。重要な変更がある場合は、サイト上の告知またはその他適切な方法によりお知らせします。変更後もサービスを利用した場合、お客様は更新後のポリシーに同意したものとみなされます。
        </p>

        <h3 class="terms-title">
          2. 収集する情報
        </h3>
        <p>
          TIGER CASINOは、サービス提供、アカウント管理、本人確認、決済処理、不正防止、サポート対応、法令遵守、マーケティング改善のため、以下の情報を収集する場合があります。
        </p>
        <ol class="terms-list">
          <li>氏名、生年月日、住所、電話番号、メールアドレス等の登録情報。</li>
          <li>アカウントID、ログイン情報、パスワード設定、本人確認状況等のアカウント情報。</li>
          <li>入金、出金、決済方法、カード情報の一部、銀行口座、ウォレット情報等の取引情報。</li>
          <li>ゲーム履歴、ベット履歴、勝敗結果、ボーナス履歴、リベート履歴等の利用情報。</li>
          <li>IPアドレス、端末情報、ブラウザ情報、Cookie、アクセスログ、位置情報に関連する技術情報。</li>
          <li>サポートへの問い合わせ内容、チャット履歴、アンケート回答、公開領域に投稿された情報。</li>
          <li>セキュリティ会社、本人確認サービス、決済会社、ゲームプロバイダー等の第三者から提供される確認情報。</li>
        </ol>
        <p>
          お客様は個人情報の提供を任意で選択できます。ただし、必要な情報が提供されない場合、アカウント登録、ゲームプレイ、入出金、本人確認、サポート対応等の一部または全部を利用できない場合があります。
        </p>

        <h3 class="terms-title">
          3. 利用目的
        </h3>
        <p>
          TIGER CASINOは、収集した個人情報を以下の目的で利用します。
        </p>
        <ul class="terms-list">
          <li>アカウント登録、本人確認、年齢確認、住所確認を行うため。</li>
          <li>ゲーム、ウォレット、決済、ボーナス、プロモーション等のサービスを提供するため。</li>
          <li>入金、出金、返金、手数料、取引確認等を処理するため。</li>
          <li>不正利用、複数アカウント、マネーロンダリング、詐欺、共謀、規約違反を防止・調査するため。</li>
          <li>お問い合わせ、苦情、技術的問題に対応するため。</li>
          <li>サービス品質、ユーザー体験、サイト機能、キャンペーン効果を分析・改善するため。</li>
          <li>法令、規制、ライセンス条件、監査、当局からの要請に対応するため。</li>
        </ul>

        <h3 class="terms-title">
          4. 第三者への提供
        </h3>
        <p>
          TIGER CASINOは、法令で認められる場合、サービス提供に必要な場合、本人確認・決済・セキュリティ・不正防止・ゲーム提供等の業務委託先へ共有する場合、またはお客様の同意がある場合を除き、個人情報を第三者へ不当に販売、貸与、開示しません。
        </p>
        <p>
          共有先には、決済サービス会社、銀行、本人確認サービス、セキュリティ事業者、ゲームプロバイダー、カスタマーサポート委託先、分析サービス、法務・監査関係者、規制当局、法執行機関等が含まれる場合があります。
        </p>

        <h3 class="terms-title">
          5. セキュリティ
        </h3>
        <p>
          TIGER CASINOは、お客様の個人情報を保護するため、SSL/TLS暗号化、アクセス制御、本人確認、監査ログ、内部管理手順等の合理的なセキュリティ対策を講じます。
        </p>
        <p>
          ただし、インターネット上の通信や電子的な保管方法は完全な安全性を保証するものではありません。お客様も、パスワードの管理、端末の保護、不審な連絡への注意等、アカウント保護にご協力ください。
        </p>

        <h3 class="terms-title">
          6. Cookieおよび技術情報
        </h3>
        <p>
          TIGER CASINOは、ログイン状態の維持、サイト機能の提供、アクセス解析、セキュリティ対策、ユーザー体験の改善、プロモーション効果測定等のためにCookieその他の類似技術を使用します。詳細はCookieポリシーをご確認ください。
        </p>

        <h3 class="terms-title">
          7. 情報の保存期間
        </h3>
        <p>
          TIGER CASINOは、サービス提供、法令遵守、紛争対応、不正防止、会計・監査、ライセンス要件のために必要な期間、個人情報を保存します。保存期間が終了した情報は、合理的な方法により削除、匿名化、または利用制限を行います。
        </p>

        <h3 class="terms-title">
          8. お客様の権利
        </h3>
        <p>
          適用法令に基づき、お客様は自身の個人情報について、確認、訂正、更新、削除、利用停止、処理制限、データ提供、同意撤回等を請求できる場合があります。請求を行う場合は、サポート窓口までご連絡ください。本人確認が必要となる場合があります。
        </p>

        <h3 class="terms-title">
          9. お問い合わせ
        </h3>
        <p>
          本ポリシー、個人情報の取扱い、またはデータ保護に関するお問い合わせは、以下へご連絡ください。
        </p>
        <ul class="terms-list">
          <li>サポート窓口：[サポートメールまたは問い合わせフォームを入力]</li>
          <li>運営会社：Aurex Global Holdings Ltd</li>
          <li>所在地：Suite 5, Arch. Makariou III Avenue 155, Limassol 3026, Cyprus</li>
        </ul>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'PrivacyTiger',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
/* 段落標題：與上一段拉開距離、貼近自己的內容 */
.terms-title {
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
}

/* 段落間距 */
.content p {
  margin: 0 0 1rem;
}

/* 項目清單：黑底上的項目符號改為白色 */
.terms-list {
  margin: 0.5rem 0 1rem 1.5rem;
}

ul.terms-list,
ol.terms-list {
  list-style-position: outside;
  padding-left: 1.4rem;
}

ul.terms-list {
  list-style: disc;
}

ol.terms-list {
  list-style: decimal;
}

.terms-list li {
  margin-bottom: 0.35rem;
}

.terms-list li::marker {
  color: #fff;
}
</style>
